import * as React from 'react';

function SvgUnreadablePlate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          fillOpacity={0.65}
          d="M21 9a2 2 0 012 2v7a2 2 0 01-2 2H3a2 2 0 01-2-2v-7c0-1.1.9-2 2-2h18zM4 12H3v6h1v-1h1v-3H4v-2zm16 1h-1v1h-1v2h2v1h-2v1h3v-3h-1v-2zm-10-1H7v1h1v2H7v3h2v-2h1v-4zm5 1h-2v1h1v2h-2v2h3v-3h1v-1h-1v-1z"
        />
        <g transform="translate(12)">
          <circle cx={6} cy={6} r={3} stroke="#FF5D52" strokeWidth={6} />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M6 2.4v3.9"
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="M5.99 9.3h.02"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgUnreadablePlate;
